<template>
	<div class="is-flex-grow-0 px-6" style="flex-basis: 15%;">
		<div class="is-flex is-justify-content-center">
			<span class="is-clickable" @click="$emit('select-date', { year: selectedDate.year - 1, month: selectedDate.month })">
				<ArrowDown class="icon_arrow_down mr-4" />
			</span>
			<span class="mt-1 text_year">{{ selectedDate.year }}</span>
			<span class="is-clickable" :class="{ 'is-disabled-local': now && selectedDate.year > now.year() }"
				@click="$emit('select-date', { year: selectedDate.year + 1, month: selectedDate.month })">
				<ArrowDown class="icon_arrow_down rotate_arrow ml-4" />
			</span>
		</div>
		<div v-for="(month, iMonth) in listMonthsNames" :key="month">
			<div class="month_btn mb-2 is-flex is-justify-content-start" :class="{
				'is-disabled-local': isMonthGreaterThanNow(iMonth),
				'is-selected': month == selectedDate.month,
				' is-clickable': !isMonthGreaterThanNow(iMonth)
			}" @click="$emit('select-date', { year: selectedDate.year, month })">
				<FileAlone
					v-if="!allMonthsData[selectedDate.year + '_' + month] || !allMonthsData[selectedDate.year + '_' + month].id || allMonthsData[selectedDate.year + '_' + month].has_error" />
				<FileCheck v-else />
				<span class="is-capitalized text_month ml-1">{{ month }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import ArrowDown from "@/components/svg/ArrowDown.vue";
import FileAlone from "@/components/svg/FileAlone.vue";
import FileCheck from "@/components/svg/FileCheck.vue";

export default {
	name: "MonthYearSidebar",
	components: { ArrowDown, FileAlone, FileCheck },
	props: {
		selectedDate: { type: Object, required: true },
		listMonthsNames: { type: Array, required: true },
		allMonthsData: { type: Object, default: () => ({}) },
		now: { type: Object, default: null },
	},
	methods: {
		isMonthGreaterThanNow(month) {
			const now = moment();
			const actualMonth = moment({ year: this.selectedDate.year, month: month });
			return now.isBefore(actualMonth);
		},
	},
};
</script>

<style scoped lang="scss">
.icon_arrow_down {
	width: 30px;
	height: 30px;
	fill: grey;
	transform: rotate(90deg);
}

.rotate_arrow {
	transform: rotate(270deg);
}

.text_year {
	color: var(--Gray-700, #344054);
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
}

.month_btn {
	border-radius: 6px;
	border: 1px solid var(--Gray-300, #D0D5DD);
	background: var(--Base-White, #FFF);
	padding: 8px 12px;

	.text_month {
		color: #002E33;
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
	}
}

.month_btn:hover,
.is-selected {
	border-radius: 6px;
	border: 1px solid #00A9AD;
	background-color: #EFFEFD;
	color: #00A9AD;
}
</style>
